// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RedoSearch-redoContainer-K35GI {
  position: absolute;
  top: 32px;
  left: 33px;
  z-index: 1;
  -webkit-box-shadow: 0px 5px 12px var(--primary-box-shadow);
          box-shadow: 0px 5px 12px var(--primary-box-shadow);
  border-radius: 6px;
  width: 100%;
  min-width: 240px;
  max-width: 240px;
  margin: 0 auto;
}

.RedoSearch-redoContent-zGvws {
  padding: 9px 12px 9px 12px;
  background-color: var(--background-primary);
  border-radius: 6px;
  -webkit-box-shadow: 0px 5px 12px var(--primary-box-shadow);
          box-shadow: 0px 5px 12px var(--primary-box-shadow);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
}

.RedoSearch-redoText-PcuU5 {
  word-wrap: break-word;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.2px;
}

.RedoSearch-redoText-PcuU5>span:first-child {
  top: 0;
}

.RedoSearch-redoText-PcuU5>span:last-child {
  position: relative;
  top: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/RedoSearch/RedoSearch.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,0DAAkD;UAAlD,kDAAkD;EAClD,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,kBAAkB;EAClB,0DAAkD;UAAlD,kDAAkD;EAClD,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV","sourcesContent":[".redoContainer {\n  position: absolute;\n  top: 32px;\n  left: 33px;\n  z-index: 1;\n  box-shadow: 0px 5px 12px var(--primary-box-shadow);\n  border-radius: 6px;\n  width: 100%;\n  min-width: 240px;\n  max-width: 240px;\n  margin: 0 auto;\n}\n\n.redoContent {\n  padding: 9px 12px 9px 12px;\n  background-color: var(--background-primary);\n  border-radius: 6px;\n  box-shadow: 0px 5px 12px var(--primary-box-shadow);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.redoText {\n  word-wrap: break-word;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: 0.2px;\n}\n\n.redoText>span:first-child {\n  top: 0;\n}\n\n.redoText>span:last-child {\n  position: relative;\n  top: 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"redoContainer": `RedoSearch-redoContainer-K35GI`,
	"redoContent": `RedoSearch-redoContent-zGvws`,
	"redoText": `RedoSearch-redoText-PcuU5`
};
module.exports = ___CSS_LOADER_EXPORT___;
